var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16.082,
    viewBox: "0 0 16.082 16.082",
    width: 16.082,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.291 2.25a8.041 8.041 0 1 0 8.041 8.041 8.065 8.065 0 0 0 -8.041-8.041zm-.632 3.45h1.264v6.318h-1.264zm.632 9.764a.862.862 0 1 1 .862-.861.883.883 0 0 1 -.862.857z",
    fill: "#eb6626",
    transform: "translate(-2.25 -2.25)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningFilled);
export default __webpack_public_path__ + "static/media/warning-filled.41aa35a27776e2d251b84a57ad4ae8ee.svg";
export { ForwardRef as ReactComponent };